<template>
  <div>
    <div class="title">
      <span>{{ $route.query.detail ? '编辑收款账户' : '添加收款账户' }}</span>
    </div>
    <el-form ref="form" :model="formInline" :rules="rules" label-width="80px" hide-required-asterisk style="padding:30px 0 0 100px">
      <el-form-item label="账户类型:" prop="bankAccountType">
        <el-select v-model="formInline.bankAccountType" placeholder="请选择" clearable>
          <el-option label="对公账户" value="PUB"></el-option>
          <el-option label="记账账户" value="PRIV"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收款银行" prop="bankName">
        <el-input v-model="formInline.bankName" clearable></el-input>
      </el-form-item>
      <el-form-item label="收款账户" prop="cardNo">
        <el-input v-model="formInline.cardNo" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="title">
      <el-button type="primary" round @click="onSubmit" :loading="loading">确定</el-button>
    </div>
  </div>
</template>
<script>
import { bankAccountUpdate, bankAccountAdd } from '@/api/epay'
export default {
  name: 'BankAccountDetail',
  data () {
    var checkBankAccountType = (rule, value, callback) => {
      var flag = new RegExp(this.$reg.name.reg)
      if (flag.test(value)) {
        return callback(new Error('请填写正确收款银行'))
      }
      callback()
    }
    var checkCardNo = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入收款账户'))
      } else if (/[^\d]/g.test(value)) {
        callback(new Error('格式错误，请输入数字'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      formInline: {
        bankAccountType: '',
        // bankCode: '',
        bankName: '',
        cardNo: '',
        // cardType: 'DC',
        cardholder: ''
      },
      rules: {
        bankAccountType: [
          { required: true, message: '请选择收款账户', trigger: ['blur', 'change'] }
        ],
        bankName: [
          { required: true, message: '请输入收款银行', trigger: 'blur' },
          { validator: checkBankAccountType, trigger: 'blur' }
        ],
        cardNo: [
          { validator: checkCardNo, trigger: 'blur' },
          { pattern: /^([1-9]{1})(\d{8}|\d{10}|\d{11}|\d{13}|\d{14}|\d{15}|\d{16}|\d{17}|\d{18}|\d{19}|\d{20}|\d{21}|\d{22})$/, message: '请填写正确收款账户', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.$route.query.detail) { this.formInline = this.$route.query.detail }
    console.log(this.formInline, 'this.formInline')
  },
  methods: {
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.$route.query.detail) {
            this.loading = true
            bankAccountUpdate({ id: this.$route.query.detail.bankAccountId, in: this.formInline }).then(res => {
              if (res.data.success) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                })
                this.$router.push({
                  path: '/epay/bankAccount'
                })
                this.loading = false
              }
            })
          } else {
            this.loading = true
            bankAccountAdd(this.formInline).then(res => {
              if (res.data.success) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.$router.push({
                  path: '/epay/bankAccount'
                })
                this.loading = false
              } else {
                this.loading = false
              }
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@deep: ~">>>";

.title {
  height: 57px;
  background: white;
  font-family: "思源黑体 Bold", "思源黑体 Regular", "思源黑体 CN Regular", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #2e2e2e;
  line-height: 57px;
  border-bottom: 1px solid rgba(234, 234, 234, 1);

  span {
    margin-left: 25px;
  }

  @{deep} .el-button {
    float: right;
    margin: 14px 78px;
  }
}

.add {
  width: 95px;
  height: 30px;
  border-radius: 30px;
  background: rgba(20, 115, 230, 1);
  color: #f4f4f4;
  border: none;
  float: right;
  margin: 13px 50px;
}
</style>
